import {forkJoin as observableForkJoin} from 'rxjs';
import {AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild} from '@angular/core';
import {AbstractControl, NgForm, UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {CompanySimpleDto, TaskDto} from '../../../bonding_shared/model/index';
import {TaskGuiService} from '../services/index';
import {DictionaryBaseDto} from '../../../bonding_shared/model/dtos';
import {UserGroupBaseDto, UserSimpleDto} from '../../../bonding_shared/model';
import {ElementaryRight, TaskStatus, TaskType, UserType} from '../../../bonding_shared/model/dictionary-ids';
import {
  AppConfigService,
  DictionaryService,
  LoggedUserService,
  RouterService,
  TaskService,
  UserService,
} from '../../../bonding_shared/services';
import {BusinessObjectSelectorComponent} from '../../../bonding_shared/components/business-object-selector/business-object-selector.component';

@Component({
  selector: 'task-data',
  templateUrl: 'task-data.component.html',
})
export class TaskDataComponent implements OnInit, AfterViewInit {
  readonly ElementaryRight = ElementaryRight;
  readonly TaskType = TaskType;
  @Input() disabled: boolean;
  _task: TaskDto = <TaskDto>{creationDate: new Date()};
  @ViewChild(BusinessObjectSelectorComponent) businessObjectSelector: BusinessObjectSelectorComponent;

  @ViewChild('ngForm', {static: true}) ngForm: NgForm;
  form: UntypedFormGroup;
  users: UserSimpleDto[];
  public errorMessage: string;
  showErrors = false;

  company: CompanySimpleDto;
  companies: CompanySimpleDto[] = [];
  groups: UserGroupBaseDto[];
  groupsForBu: UserGroupBaseDto[];
  usersForBu: UserSimpleDto[];
  @Input() assignmentUnlocked = true;
  @Input() dueDateUnlocked = true;
  historyMode = false;

  boRequired = true;
  relatedToRegExp: RegExp;
  typeEditable = true;

  static validateUserAndGroup(group: AbstractControl, appConfig: AppConfigService) {
    const user = group.get('user');
    const userGroup = group.get('userGroup');
    if (!user || !userGroup) {
      return null;
    }
    return user.value || userGroup.value ? null : {missingAssignee: true};
  }

  constructor(
    private routerService: RouterService,
    private userService: UserService,
    private dictionaryService: DictionaryService,
    private taskGuiService: TaskGuiService,
    private taskService: TaskService,
    private formBuilder: UntypedFormBuilder,
    public appConfig: AppConfigService,
    private cd: ChangeDetectorRef,
    public loggedUserService: LoggedUserService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadUsersAndGroups();
  }

  ngAfterViewInit(): void {
    this.form = this.ngForm.form;
  }

  get task(): TaskDto {
    return this._task;
  }

  @Input()
  set task(t: TaskDto) {
    this._task = t;
    if (t && t.status && t.status.id !== TaskStatus.OPEN) {
      this.historyMode = true;
    }
    if (!t.id) {
      this.typeEditable = true;
    } else {
      this.typeEditable = false;
    }
  }

  loadUsersAndGroups() {
    observableForkJoin(this.userService.getIntranetUsers(), this.userService.getUserGroups()).subscribe((res) => {
      this.users = <UserSimpleDto[]>res[0];
      this.groups = <UserGroupBaseDto[]>res[1];
      this.setGroupsAndUsersForBu();
    });
  }

  public setGroupsAndUsersForBu() {
    if (this.task) {
      this.groupsForBu = this.groups.filter((g) => g.businessUnit?.id === this.task.businessUnit?.id);
      this.usersForBu = this.users.filter(
        (g) => g.businessUnit?.id === this.task.businessUnit?.id && g.userType.id === UserType.INTRANET
      );
    }
  }

  onBUChange(bu: DictionaryBaseDto) {
    this.task.user = undefined;
    this.task.userGroup = undefined;
    this.setGroupsAndUsersForBu();
  }

  isFidat() {
    return this.task?.type?.id === TaskType.FIDAT_RATING_REVIEW;
  }

  isAssignmentReadonly(): boolean {
    return !this.assignmentUnlocked || this.historyMode;
  }

  onTypeChange($event: DictionaryBaseDto) {
    if ($event.id === TaskType.FIDAT_RATING_REVIEW) {
      this.taskService
        .initialVersion(
          this.task.businessObject?.relatedTo?.id,
          this.task.businessObject?.relatedToId,
          TaskType.FIDAT_RATING_REVIEW
        )
        .subscribe((task) => {
          this.task = task;
          this.setGroupsAndUsersForBu();
        });
    }
  }
}
